import React from 'react';
import { Box } from '@material-ui/core';
import { MenuItem, Select } from '@material-ui/core';
import { useTheme } from '@material-ui/core';
import { useIntl } from 'umi';
import PaginationStyled from './InitPaginationStyled';

export default (props) => {
  const theme = useTheme();
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const {
    page,
    changePages,
    mt = 3,
    hasNext,
    showPagingDataStatus,
    pages,
    showPageColor,
  } = props;
  const { pageNum = 1 } = page;
  const changePageSize = (e) => {
    const selectdPageSize = e.target.value;
    changePages({ pageSize: selectdPageSize, pageNum: 1 });
  };

  const previousPage = () => {
    if (Number(pageNum) > 1) {
      const selectdPageNum = Number(pageNum) - 1;
      changePages({ ...page, pageNum: selectdPageNum });
    }
  };

  const nextPage = () => {
    // return;
    if (hasNext) {
      const selectdPageNum = Number(pageNum) + 1;
      changePages({ ...page, pageNum: selectdPageNum });
    }
  };
  return (
    <PaginationStyled theme={theme}>
      <Box className="commentBox" mt={mt}>
        <Box
          onClick={previousPage}
          sx={{
            padding: '0 15px',
            height: '32px',
            textAlign: 'center',
            lineHeight: '32px',
            cursor: 'pointer',
            color: Number(pageNum) > 1 ? '#1565c0' : '#C9C9C9',
          }}
        >
          {formatMessage({ id: 'comm.pagination.lbl.03' })}
        </Box>
        {showPagingDataStatus && pageNum && (
          <Box color={showPageColor ? '#1565c0' : '#212121'}>第{pageNum}页</Box>
        )}
        <Box
          onClick={nextPage}
          sx={{
            padding: '0 15px',
            height: '32px',
            textAlign: 'center',
            lineHeight: '32px',
            marginRight: !showPagingDataStatus ? '15px' : 0,
            cursor: 'pointer',
            color: hasNext ? '#1565c0' : '#C9C9C9',
          }}
        >
          {formatMessage({ id: 'comm.pagination.lbl.04' })}
        </Box>
        {showPagingDataStatus && (pages || Number(pages) === 0) && (
          <Box color={showPageColor ? '#1565c0' : '#212121'}>共{pages}页</Box>
        )}
        {!showPagingDataStatus && (
          <span className="page-size">
            <Select
              className="select"
              variant="outlined"
              defaultValue={10}
              value={page?.pageSize || 10}
              onChange={changePageSize}
              label=""
            >
              {[
                {
                  id: 10,
                  name: `10${formatMessage({
                    id: 'comm.pagination.lbl.06',
                  })}/${formatMessage({ id: 'comm.pagination.lbl.05' })}`,
                },
                {
                  id: 50,
                  name: `50${formatMessage({
                    id: 'comm.pagination.lbl.06',
                  })}/${formatMessage({ id: 'comm.pagination.lbl.05' })}`,
                },
                {
                  id: 100,
                  name: `100${formatMessage({
                    id: 'comm.pagination.lbl.06',
                  })}/${formatMessage({ id: 'comm.pagination.lbl.05' })}`,
                },
              ].map((item) => (
                <MenuItem
                  key={item.id}
                  value={item.id}
                  name={item.id}
                  // onClick={(id) => {
                  //   console.log('id', id);
                  //   changePages({ ...page, pageSize: id });
                  // }}
                >
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </span>
        )}
      </Box>
    </PaginationStyled>
  );
};
